'use client';

import { useLocale } from 'next-intl';
import { useEffect, useRef } from 'react';
import 'vanilla-cookieconsent/dist/cookieconsent.css';
import * as CookieConsent from 'vanilla-cookieconsent';
import { getConsentConfig } from './cookieConsentConfig';

// Countries requiring cookie consent (ISO 3166-1 alpha-2)
// UK + EU member states
const CONSENT_REQUIRED_COUNTRIES = new Set([
  'GB', // United Kingdom
  // EU member states
  'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR',
  'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL',
  'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE'
]);

/**
 * Get user's country from cookie or URL param (for testing)
 */
function getUserCountry() {
  if (typeof document === 'undefined') return '';

  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('forceCountry') || document.cookie.match(/user-country=([^;]+)/)?.[1] || '';
}

/**
 * Check if user needs cookie consent based on country
 */
function needsConsent() {
  return CONSENT_REQUIRED_COUNTRIES.has(getUserCountry());
}

export default function CookieConsentBanner() {
  const locale = useLocale();
  const initializedRef = useRef(false);

  // Initialize library once
  useEffect(() => {
    if (initializedRef.current) return;
    initializedRef.current = true;

    CookieConsent.run(getConsentConfig(locale));
  }, [locale]);

  // Show banner only for UK/EU users
  useEffect(() => {
    if (!needsConsent()) return; // Skip for non-UK/EU users

    if (!CookieConsent.validConsent()) {
      setTimeout(() => {
        CookieConsent.show();
        document.documentElement.classList.add('show--consent');
      }, 100);
    }
  }, [locale]);

  return null;
}
